import type { UnitInterestedLead } from '../../services/api';
import type { RootScope } from '../../types';

import React from 'react';

import { tel } from '../../est/filters';
import { LeadName } from '../../lead.popup/common';
import { getService } from '../../shell';
import { Button } from '../../ui';

export type ApplyLeadButtonProps = {
  label: string | React.ReactElement;
  className?: string;
  loading?: boolean;
  onClick(): any;
};

export function ApplyLeadButton({
  label,
  className,
  loading,
  onClick,
}: ApplyLeadButtonProps) {
  const lead = useCurrentLead();

  if (!lead) {
    return null;
  }

  return (
    <Button className={className} block loading={loading} onClick={onClick}>
      <span>{label}</span>
      <b className="g-truncate">
        <LeadName name={lead.name} />
        {!!lead.phone && ` +${tel(lead.phone)}`}
        {!!lead.email && ` ${lead.email}`}
      </b>
    </Button>
  );
}

export const useCurrentLead = (): UnitInterestedLead | null => {
  const [, setRefresh] = React.useState(0);

  React.useEffect(() => {
    const $rootScope = getService<RootScope>('$rootScope');

    const unsubscribe = $rootScope.$on('new.ls.lead', () =>
      setRefresh(Date.now()),
    );

    return unsubscribe;
  }, []);

  return getCurrentLead();
};

export const getCurrentLead = (): UnitInterestedLead | null => {
  const localStorageService =
    getService<angular.local.storage.ILocalStorageService>(
      'localStorageService',
    );

  return localStorageService.get('lead') || null;
};
